import React from "react";

function PopularityOfNFTs() {
  return (
    <div>
      {" "}
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                The increasing popularity of NFTs
              </h2>
              <p>
                NFTs (Non-Fungible Tokens) have rapidly gained popularity as
                they revolutionize the way digital assets are created, owned,
                and traded. Unlike traditional cryptocurrencies, each NFT
                represents a unique item, whether it's digital art,
                collectibles, music, virtual real estate, or in-game assets. The
                surge in interest is driven by creators, investors, and
                businesses recognizing the potential of NFTs to authenticate
                ownership and provide scarcity in the digital world. As
                blockchain technology evolves, NFTs are becoming a crucial part
                of the decentralized economy, offering new revenue streams and
                creative opportunities for both individuals and enterprises.
              </p>

              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopularityOfNFTs;
